import { useQuery } from '@tanstack/react-query'
import { TIERED_FEE_POLICY } from '../utils/constants'
import { resolveGuestServiceFeePct } from '../utils/tiered-fee'
import { bookingService } from '../services/booking.service'
import { useAuth } from './use-auth'

export const pairFeeKeys = {
  all: ['pair-fee'] as const,
  pair: (guestId: string, hostId: string) => [...pairFeeKeys.all, guestId, hostId] as const,
}

export function usePairFee(hostId: string | null | undefined) {
  const { user } = useAuth()
  const guestId = user?.id ?? ''
  const enabled = Boolean(guestId && hostId)

  const query = useQuery({
    queryKey: pairFeeKeys.pair(guestId, hostId ?? ''),
    queryFn: () => bookingService.getCompletedPairRentals(guestId, hostId!),
    enabled,
    staleTime: 60 * 1000,
    retry: false,
  })

  const completedPairTrips = query.data ?? 0
  const guestServiceFeePct = resolveGuestServiceFeePct(completedPairTrips, TIERED_FEE_POLICY)

  return {
    completedPairTrips,
    guestServiceFeePct,
    isLoading: query.isLoading,
    isReady: !enabled || !query.isPending,
  }
}
